import React from 'react'
import Acceuil from './Acceuil';


function App() {
  return (
    <div>
      <Acceuil />
    </div>
  );
}

export default App;
